import { TripOrderingTable } from '../../../global/interfaces';
import { Actions } from './actions';
import {
  GET_ORDERING_TRIPS_REQUEST,
  GET_ORDERING_UNLOADING_TRIPS_REQUEST,
  GET_ORDERING_TRIPS_SUCCESS,
  GET_ORDERING_TRIPS_ERROR,
} from './constants';

const initialState = {
  trips: [] as TripOrderingTable[],
  loading: false as boolean,
  error: null as Error | null,
};

type TripsTabState = typeof initialState;

export const tripsTabReducer = (state: TripsTabState = initialState, action: Actions) => {
  switch (action.type) {
    case GET_ORDERING_TRIPS_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case GET_ORDERING_UNLOADING_TRIPS_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case GET_ORDERING_TRIPS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
        trips: action.payload.trips,
      };
    }
    case GET_ORDERING_TRIPS_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    }
    default: {
      return state;
    }
  }
};
